import React from 'react';

import { cn } from '../../utils/classname';
import './label.scss';

type LabelProps = {
  className?: string;
};

export const Label: React.FC<LabelProps> = ({ children, className }) => {
  const classes = cn('rc-field-label', className);
  return <label className={classes}>{children}</label>;
};
